module.exports = __webpack_public_path__ + "img/withdrawal.972c5805.svg";